/**
 * toserof-load-more.js — Koleksiyon sayfaları: otomatik sonsuz kaydırma + "Daha Fazla Yükle" butonu.
 *
 * v2 (2026-07-10): Scroll Freely app'inin yerine geçen KOTASIZ otomatik yükleme.
 *  - Kullanıcı listenin dibine yaklaşınca sonraki 40 ürün otomatik eklenir (IntersectionObserver).
 *  - Her AUTO_CHECKPOINT otomatik yüklemede bir durur ve butona basılmasını ister
 *    (Scroll Bee'deki sınırsız yükleme mobilde bellek çökmesi yapmıştı — sigorta).
 *  - Eklenen kartların görselleri loading="lazy" yapılır (temada eager sabit; ekli
 *    partilerde ancak görünüme yaklaşan görsel indirilir).
 *  - Mükerrer koruması: DOM'da zaten olan ürün linki tekrar eklenmez.
 *  - Scroll Freely (eosh) app'i hâlâ aktifse otomatik mod KAPALI kalır (yalnızca buton,
 *    bugünkü davranış) — çifte otomatik yükleme/mükerrer olmaz. App kaldırılınca
 *    otomatik mod kendiliğinden devreye girer.
 *
 * Yalnızca #custom-pagination olan sayfalarda (koleksiyon) çalışır; arama ve
 * koleksiyon-listesi kendi görünür sayfalamalarını kullanır (dokunulmaz).
 */
(function () {
  'use strict';

  var GRID_SEL = '#CollectionAjaxContent .collection-grid__wrapper .grid--uniform';
  var NEXT_SEL = '#custom-pagination .next a';
  var WRAP_ID = 'toserof-load-more-wrap';
  var BTN_ID = 'toserof-load-more';
  var LABEL = 'Daha Fazla Yükle';
  var LOADING_LABEL = 'Yükleniyor…';
  var AUTO_CHECKPOINT = Infinity; // sınırsız otomatik yükleme (görseller lazy olduğundan bellek riski düşük);
                                  // sayı verilirse o kadar otomatik partiden sonra bir kez buton ister
  var AUTO_ROOT_MARGIN = '1200px'; // dibe bu kadar px kala tetikle

  var nextUrl = null;
  var loading = false;
  var autoCount = 0;             // checkpoint'ten beri yapılan otomatik yükleme sayısı
  var observer = null;

  // Scroll Freely app'i aktifken otomatik modu kapat (çifte yükleme olmasın).
  // window.TOSEROF_FORCE_AUTO test amaçlı zorlamaya izin verir.
  var APP_ACTIVE = !window.TOSEROF_FORCE_AUTO &&
    !!document.querySelector('script[src*="eosh-loadmore"], script[src*="eosh-storefront"]');

  // Otomatik mod: buton hiç GÖRÜNMEZ (görünmez tetik noktası); ürünler sessizce eklenir.
  // Buton yalnızca yedek modda (app aktif veya IntersectionObserver yok) görünür.
  var AUTO_MODE = !APP_ACTIVE && ('IntersectionObserver' in window);

  function injectStyleOnce() {
    if (document.getElementById('toserof-load-more-style')) return;
    var s = document.createElement('style');
    s.id = 'toserof-load-more-style';
    s.textContent =
      '#' + WRAP_ID + '{width:100%;text-align:center;margin:34px 0 12px;clear:both;}' +
      '#' + BTN_ID + '{display:inline-block;min-width:230px;padding:14px 30px;font-size:13px;' +
      'letter-spacing:.08em;text-transform:uppercase;cursor:pointer;background:transparent;' +
      'color:inherit;border:1px solid currentColor;border-radius:0;transition:opacity .2s;}' +
      '#' + BTN_ID + ':hover{opacity:.7;}' +
      '#' + BTN_ID + '[disabled]{opacity:.45;cursor:default;}';
    document.head.appendChild(s);
  }

  function getGrid() {
    return document.querySelector(GRID_SEL);
  }

  function readNext(root) {
    var a = (root || document).querySelector(NEXT_SEL);
    return a ? a.getAttribute('href') : null;
  }

  // Append edilecek kartların AOS "opacity:0" animasyonuna takılıp görünmez kalmaması için
  // data-aos özniteliklerini temizle (kart anında görünür).
  function stripAos(node) {
    if (node.hasAttribute && node.hasAttribute('data-aos')) node.removeAttribute('data-aos');
    var kids = node.querySelectorAll ? node.querySelectorAll('[data-aos]') : [];
    for (var i = 0; i < kids.length; i++) kids[i].removeAttribute('data-aos');
  }

  // Temada kart görselleri loading="eager" sabit; sonradan eklenen partilerde
  // lazy'ye çevir ki yalnızca görünüme yaklaşanlar indirilsin (sayfa yavaşlamasın).
  function lazifyImages(node) {
    var imgs = node.querySelectorAll ? node.querySelectorAll('img') : [];
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('loading', 'lazy');
      imgs[i].setAttribute('fetchpriority', 'low');
    }
  }

  // Karttaki ürün linki (mükerrer tespiti için anahtar)
  function productKey(node) {
    if (!node.querySelector) return null;
    var a = node.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  // Grid'de halihazırda bulunan ürünlerin anahtar kümesi
  function existingKeys(grid) {
    var set = {};
    var links = grid.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) set[links[i].getAttribute('href').split('?')[0]] = 1;
    return set;
  }

  function build() {
    // Filtreleme/sıralama AJAX'ından sonra eski butonu temizle
    var old = document.getElementById(WRAP_ID);
    if (old) old.remove();
    if (observer) { observer.disconnect(); observer = null; }
    autoCount = 0;

    var grid = getGrid();
    if (!grid) return;                 // koleksiyon grid'i yok
    nextUrl = readNext(document);
    if (!nextUrl) return;              // tek sayfa: buton gerekmez

    injectStyleOnce();

    var wrap = document.createElement('div');
    wrap.id = WRAP_ID;
    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.type = 'button';
    btn.textContent = LABEL;
    btn.addEventListener('click', function () {
      autoCount = 0;                   // butona basınca otomatik hakkı tazelenir
      loadMore();
    });
    wrap.appendChild(btn);

    if (AUTO_MODE) {
      // Görünmez tetik noktası: yer kaplamaz, buton/yükleniyor yazısı hiç görünmez.
      wrap.style.cssText = 'margin:0;padding:0;height:1px;overflow:hidden;visibility:hidden;';
      btn.tabIndex = -1;
      btn.setAttribute('aria-hidden', 'true');
    }

    // Butonu #CollectionAjaxContent'in DIŞINA (kardeş) koy ki filtre re-render'ında silinmesin
    var anchor = document.getElementById('CollectionAjaxContent');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      var w = grid.closest('.collection-grid__wrapper') || grid;
      w.parentNode.insertBefore(wrap, w.nextSibling);
    }

    armObserver();
  }

  // Tetik noktası görünüme yaklaşınca otomatik yükle (app aktifse devre dışı)
  function armObserver() {
    if (!AUTO_MODE) return;
    var wrap = document.getElementById(WRAP_ID);
    if (!wrap) return;
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        if (loading || !nextUrl) return;
        if (autoCount >= AUTO_CHECKPOINT) return; // sigorta: butonla devam
        autoCount++;
        loadMore();
        return;
      }
    }, { rootMargin: AUTO_ROOT_MARGIN + ' 0px' });
    observer.observe(wrap);
  }

  function loadMore() {
    if (loading || !nextUrl) return;
    var btn = document.getElementById(BTN_ID);
    var grid = getGrid();
    if (!btn || !grid) return;
    loading = true;
    btn.disabled = true;
    btn.textContent = LOADING_LABEL;

    fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID_SEL);
        var added = 0;
        if (newGrid) {
          var seen = existingKeys(grid);
          var kids = Array.prototype.slice.call(newGrid.children);
          var frag = document.createDocumentFragment();
          for (var i = 0; i < kids.length; i++) {
            var key = productKey(kids[i]);
            if (key && seen[key]) continue; // mükerrer: bu ürün DOM'da zaten var
            var imported = document.importNode(kids[i], true); // custom element'ler (image-element) upgrade olsun
            stripAos(imported);
            lazifyImages(imported);
            frag.appendChild(imported);
            added++;
          }
          grid.appendChild(frag);
        }

        nextUrl = readNext(doc);

        // Quick-shop / swatch / AOS yeniden bağla (tema fonksiyonu)
        if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
          try { window.theme.reinitProductGridItem(); } catch (e) {}
        }

        loading = false;

        if (!nextUrl) {
          var wrap = document.getElementById(WRAP_ID);
          if (wrap) wrap.remove(); // son sayfa
          if (observer) { observer.disconnect(); observer = null; }
          return;
        }

        btn.disabled = false;
        btn.textContent = LABEL;

        // Kısa parti eklendiğinde buton hâlâ görünüm marjında kalabilir; observer'ı
        // tazele ki gerekiyorsa zinciri sürdürsün (isIntersecting değişmeden tekrar tetiklenmez).
        if (observer) {
          var wrapEl = document.getElementById(WRAP_ID);
          if (wrapEl) { observer.unobserve(wrapEl); observer.observe(wrapEl); }
        }

        // Sayfadaki her şey mükerrer çıktıysa (ör. app önceden yüklemiş) bir sonraki
        // sayfaya ilerle — kullanıcı boş tıklamış gibi olmasın.
        if (added === 0) loadMore();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = LABEL;
        loading = false;
      });
  }

  function init() {
    build();
    // Tema, filtre/sıralamada #CollectionAjaxContent'i yeniden render eder → butonu tazele
    document.addEventListener('collection:reloaded', function () {
      setTimeout(build, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
